import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Spinner } from "react-bootstrap";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { ACTIVITY_ORDERS, ACTIVITY_ORDER } from "../../graphql/order/query";
import { SALEPAGE_CANCEL_ORDER, SALEPAGE_ReJECT_ORDER } from "../../graphql/order/mutation";
import { FaEye } from "react-icons/fa";
import RefundOrder from "./components/RefundOrder";
import { useToasts } from "react-toast-notifications";
import { v4 as uuidv4 } from "uuid";
import { GET_PRESIGN_URL } from "../../graphql/presignUrl/query";
import { S3_URL } from "../../constants";

function RefundedPage() {
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const [refundOrders, setRefundOrders] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showBankModal, setShowBankModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const { addToast } = useToasts();
  const [cancelNote, setCancelNote] = useState("");
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    cancelNote: false,
    file: false
  });

  const [salepagecancelorder] = useMutation(SALEPAGE_CANCEL_ORDER);
  const [salepagerejectorder] = useMutation(SALEPAGE_ReJECT_ORDER);

  const { data: activityOrders, loading, error } = useQuery(ACTIVITY_ORDERS, {
    fetchPolicy: "cache-and-network",
  });

  const [fetchActivityOrder, { data: activityOrder, loading: loadingDetail }] =
    useLazyQuery(ACTIVITY_ORDER, { fetchPolicy: "cache-and-network" });

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  useEffect(() => {
    if (activityOrders?.activityOrders?.data) {
      setRefundOrders(activityOrders.activityOrders.data);
    }
  }, [activityOrders]);

  const handleRowClick = (id) => {
    setSelectedId(id);
    fetchActivityOrder({
      variables: {
        where: { id },
      },
    });
    setShowDetail(true);
  };

  const handleShowBankModal = () => {
    setShowBankModal(true);
  };

  const handleCancel = () => {
    setShowCancelModal(true);
  }

  const handleClose = () => {
    setShowDetail(false);
    setShowBankModal(false);
    setShowCancelModal(false);
    setSelectedId(null);
  };

  const handleReject = async () => {
    if (!rejectNote.trim()) {
      addToast("ກະລຸນາໃຫ້ເຫດຜົນການປະຕິເສດການຄືນເງິນ", {
        appearance: "success",
        autoDismiss: true,
        timer: 3000,
      });
      return;
    }
    try {
      const { data } = await salepagerejectorder({
        variables: {
          input: {
            note: rejectNote,
            shopId: shop?.id,
            userId: activityOrder?.activityOrder?.data?.userId?.id,
            orderGroupId: activityOrder?.activityOrder?.data?.orderGroupId?.id,
          },
        },
        refetchQueries: [{ query: ACTIVITY_ORDERS }],
      });

      const result = data?.rejectOrderCancel;

      if (result?.status) {
        addToast("ຍົກເລີກອໍເດີສຳເລັດ", {
          appearance: "success",
          autoDismiss: true,
          timer: 3000,
        });
        handleClose();
      } else {
        addToast(result?.msg || "ການຍົກເລີກລົ້ມເຫລວ", {
          appearance: "error",
          autoDismiss: true,
          timer: 3000,
        });
      }
      handleClose();
    } catch (error) {
      console.error("❌ Error rejecting refund:", error);
      addToast("ການຍົກເລີກລົ້ມເຫລວ", {
        appearance: "error",
        autoDismiss: true,
        timer: 3000,
      });
    }
    handleClose();
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    try {
      setUploading(true);
      setFile(selectedFile);

      // Create local preview immediately
      const localPreview = URL.createObjectURL(selectedFile);
      setPreviewUrl(localPreview);

      var ext = selectedFile.name.split(".").pop();
      let filename = uuidv4() + "." + ext;

      const { data } = await getPresignUrl({
        variables: { name: filename },
      });

      const uploadUrl = data?.preSignedUrl?.url;
      if (!uploadUrl) throw new Error("Failed to get presigned URL");

      await fetch(uploadUrl, {
        method: "PUT",
        body: selectedFile,
        headers: { "Content-Type": selectedFile.type },
      });
      setFileName(filename);
      setTimeout(() => {
        URL.revokeObjectURL(localPreview);
        setPreviewUrl(null);
      }, 2000);

    } catch (err) {
      console.error("❌ Upload error:", err);
      setPreviewUrl(null);
      addToast("ອັບໂຫລດຮູບລົ້ມເຫລວ", {
        appearance: "error",
        autoDismiss: true,
        timer: 3000,
      });
    } finally {
      setUploading(false);
    }
  };

  const handleCancelOrder = async () => {
    if (!fileName) {
      setValidationErrors({
        file: true,
        cancelNote: false
      });
      return;
    }
    if (!cancelNote.trim()) {
      setValidationErrors({
        cancelNote: true,
        file: false
      });
      return;
    }
    try {
      const { data } = await salepagecancelorder({
        variables: {
          input: {
            note: cancelNote,
            image: fileName,
            shopId: shop?.id,
            userId: activityOrder?.activityOrder?.data?.userId?.id,
            orderGroupId: activityOrder?.activityOrder?.data?.orderGroupId?.id,
          },
        },
        refetchQueries: [{ query: ACTIVITY_ORDERS }],
      });
      const result = data?.salePageCancelOrder;
      if (result?.status) {
        addToast("ຍົກເລີກອໍເດີສຳເລັດ", {
          appearance: "success",
          autoDismiss: true,
          timer: 3000,
        });
        handleClose()
      } else {
        addToast(result?.msg || "ການຍົກເລີກລົ້ມເຫລວ", {
          appearance: "error",
          autoDismiss: true,
          timer: 3000,
        });
      }
      handleClose();
    } catch (error) {
      console.error("❌ Error canceling order:", error);
      addToast("ການຍົກເລີກລົ້ມເຫລວ", {
        appearance: "error",
        autoDismiss: true,
        timer: 3000,
      });
      handleClose();
    }
  }

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "120px",
          width: "100%",
        }}
      >
        <p style={{ color: "gray", fontWeight: "bold" }}>
          ກຳລັງໂຫລດຂໍ້ມູນ...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "120px",
          width: "100%",
        }}
      >
        <p style={{ color: "red", fontWeight: "bold" }}>
          ເກີດຂໍ້ຜິດພາດ: {error.message}
        </p>
      </div>
    );
  }

  return (
    <>
      <div style={{ padding: "0 9px" }}>
        {refundOrders.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "120px",
              width: "100%",
            }}
          >
            <p
              style={{
                color: "gray",
                fontWeight: "bold",
                margin: 0,
                textAlign: "center",
              }}
            >
              !ບໍ່ພົບຂໍ້ມູນ
            </p>
          </div>
        ) : (
          <ListStockSalePage
            orderLists={refundOrders}
            reportStockOrderLoading={loading}
            createLoading={false}
            onRowClick={handleRowClick}
          />
        )}
      </div>

      {/* Modal for detail view */}
      <Modal show={showDetail} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>ລາຍລະອຽດການສັ່ງຊື້</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingDetail ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "150px",
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : activityOrder?.activityOrder?.data ? (
            <RefundOrder
              key={selectedId}
              data={activityOrder.activityOrder.data}
            />
          ) : (
            <p style={{ textAlign: "center", color: "gray" }}>ບໍ່ພົບຂໍ້ມູນ</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleShowBankModal}>
            ຄືນເງີນ
          </Button>
          <Button variant="danger" onClick={handleCancel}>
            ຍົກເລີກ
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            ປິດ
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showBankModal} onHide={handleClose} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>ຂໍ້ມູນບັນຊີທະນາຄານ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activityOrder?.activityOrder?.data?.userId?.bank?.length > 0 ? (
            activityOrder.activityOrder.data.userId.bank.map((bank, index) => (
              <div key={index} className="text-center">
                <h5 className="mb-3" style={{ color: "#0d6efd" }}>
                  {bank.bankName || "ບໍ່ມີຊື່ທະນາຄານ"}
                </h5>
                <p>
                  <strong>ຊື່ບັນຊີ:</strong> {bank.bankAccountName || "-"}
                </p>
                <p>
                  <strong>ເລກບັນຊີ:</strong> {bank.bankAccountNo || "-"}
                </p>
                <div style={{ marginTop: "16px" }}>
                  <img
                    src={bank.qrImage && bank.qrImage !== "" ? bank.qrImage : "/images/sample-qr.png"}
                    alt="QR Code"
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{ marginTop: "24px", textAlign: "left" }}>
                  <label className="form-label fw-bold">ໝາຍເຫດ / ຂໍ້ມູນການໂອນ:</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="ພິມຂໍ້ມູນການໂອນ ຫຼື ຄໍາອະທິບາຍ..."
                    style={{
                      resize: "none",
                      borderColor: validationErrors.cancelNote ? '#dc3545' : '',
                      backgroundColor: validationErrors.cancelNote ? '#fff8f9' : '',
                      boxShadow: validationErrors.cancelNote ? '0 0 0 0.2rem rgba(220,53,69,.25)' : 'none'
                    }}
                    value={cancelNote}
                    onChange={(e) => {
                      setCancelNote(e.target.value);
                      if (e.target.value.trim()) {
                        setValidationErrors(prev => ({ ...prev, cancelNote: false }));
                      }
                    }}
                  ></textarea>
                  <div className="mt-4">
                    <label className="form-label fw-bold d-block mb-2">
                      ອັບໂຫລດຫຼັກຖານການໂອນ:
                    </label>
                    <div
                      style={{
                        border: `2px dashed ${validationErrors.file ? '#dc3545' : '#cbd5e0'}`,
                        borderRadius: "12px",
                        padding: "20px",
                        textAlign: "center",
                        backgroundColor: validationErrors.file ? '#fff8f9' : "#f9fafb",
                        transition: "0.3s",
                        boxShadow: validationErrors.file ? '0 0 0 0.2rem rgba(220,53,69,.25)' : 'none'
                      }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        id="fileUpload"
                        className="d-none"
                      />
                      {!fileName ? (
                        <>
                          <label
                            htmlFor="fileUpload"
                            style={{
                              display: "inline-block",
                              cursor: "pointer",
                              padding: "8px 18px",
                              backgroundColor: "#0d6efd",
                              color: "#fff",
                              borderRadius: "6px",
                              fontWeight: "500",
                              fontSize: "0.95rem",
                            }}
                          >
                            ເລືອກຮູບຫຼັກຖານ
                          </label>
                          <p style={{ fontSize: "0.85rem", color: "#6c757d", marginTop: "8px" }}>
                            ຮອງຮັບພາບ .jpg, .png, .jpeg (ຂະໜາດບໍ່ເກີນ 5MB)
                          </p>
                        </>
                      ) : (
                        <div style={{ position: "relative", display: "inline-block" }}>
                          <img
                            src={previewUrl || (S3_URL + fileName)}
                            alt="ຮູບຫຼັກຖານການໂອນ"
                            style={{
                              width: "200px",
                              height: "200px",
                              objectFit: "cover",
                              borderRadius: "12px",
                              border: "1px solid #dee2e6",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                              opacity: uploading ? 0.7 : 1,
                            }}
                            onError={(e) => {
                              console.error('Image failed to load:', {
                                url: previewUrl || (S3_URL + fileName),
                                error: e,
                                timestamp: new Date().toISOString()
                              });
                              if (!previewUrl && file) {
                                const fallbackPreview = URL.createObjectURL(file);
                                setPreviewUrl(fallbackPreview);
                              }
                            }}
                          />
                          {uploading && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                              }}
                            >
                              ກຳລັງອັບໂຫລດ...
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              if (previewUrl) {
                                URL.revokeObjectURL(previewUrl);
                              }
                              setFile(null);
                              setFileName(null);
                              setPreviewUrl(null);
                            }}
                            style={{
                              position: "absolute",
                              top: "6px",
                              right: "6px",
                              border: "none",
                              backgroundColor: "rgba(0,0,0,0.6)",
                              color: "white",
                              borderRadius: "50%",
                              width: "28px",
                              height: "28px",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                            title="ລຶບຮູບ"
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", color: "gray" }}>
              ບໍ່ພົບຂໍ້ມູນບັນຊີທະນາຄານ
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleCancelOrder}>ຢືນຢັນການໂອນເງິນ</Button>
          <Button variant="secondary" onClick={handleClose}>
            ປິດ
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showCancelModal} onHide={handleClose} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>ເຫດຜົນການປະຕິເສດການຄືນເງີນ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginTop: "24px", textAlign: "left" }}>
            <label className="form-label fw-bold">ໝາຍເຫດ / ຂໍ້ມູນການຄືນເງີນ:</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="ຄໍາອະທິບາຍ..."
              style={{ resize: "none" }}
              value={rejectNote}
              onChange={(e) => setRejectNote(e.target.value)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleReject}>ຢືນຢັນ</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RefundedPage;
const ListStockSalePage = ({
  orderLists,
  reportStockOrderLoading,
  createLoading,
  onRowClick,
}) => {
  if (reportStockOrderLoading || createLoading)
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <p style={{ color: "gray" }}>ກຳລັງໂຫລດ...</p>
      </div>
    );

  return (
    <Table responsive hover>
      <thead>
        <tr style={{ whiteSpace: "nowrap" }}>
          <th>ລຳດັບ</th>
          <th>ຊື່ລູກຄ້າ</th>
          <th>ລະຫັດຄຳສັ່ງຊື້</th>
          <th>ລາຄາລວມ</th>
          <th>ຈຳນວນ</th>
          <th>ສະຖານະ</th>
          <th>ວັນທີ່ສ້າງຊື້</th>
          <th>ເບີ່ງລາຍລະອຽດ</th>
        </tr>
      </thead>
      <tbody>
        {orderLists && orderLists.length > 0 ? (
          orderLists.map((order, index) => (
            <tr
              key={index}
            >
              <td>{index + 1}</td>
              <td style={{ fontWeight: "bold" }}>
                {order?.userId?.firstName || "N/A"}
              </td>
              <td>{order?.orderGroupId?.code || "N/A"}</td>
              <td style={{ fontWeight: "bold" }}>
                {order?.orderGroupId?.sumPrice?.toLocaleString() || "0"}
              </td>
              <td style={{ fontWeight: "bold" }}>
                {order?.orderGroupId?.amount || "-"}
              </td>
              <td style={{ fontWeight: "bold" }}>
                <span
                  style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    backgroundColor:
                      order?.status === "REFUND_PROCESSING"
                        ? "#fff3cd"
                        : "#d4edda",
                    color:
                      order?.status === "REFUND_PROCESSING"
                        ? "#856404"
                        : "#155724",
                  }}
                >
                  {order?.status === "REFUND_PROCESSING"
                    ? "ດໍາເນີນການຄືນເງິນ"
                    : order?.status || "N/A"}
                </span>
              </td>
              <td>
                {order?.orderGroupId?.createdAt
                  ? new Date(order.orderGroupId.createdAt).toLocaleDateString(
                    "lo-LA"
                  )
                  : "N/A"}
              </td>
              <td>
                <Button
                  style={{
                    borderRadius: ".2em",
                    fontSize: ".8em",
                    backgroundColor: "#5274d1ff",
                    color: "#fff",
                  }}
                  onClick={() => onRowClick(order.id)}
                  variant="light">
                  <FaEye /> ລາຍລະອຽດ
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
              ບໍ່ມີຂໍ້ມູນ
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

